module.exports = new __parcel__URL__("speaker.20e5ad03.glb").toString();